/** @jsx jsx */

import { Button, jsx } from "theme-ui"
import { useTrail, useTransition, animated as a } from "react-spring"
import RemoveIcon from "@material-ui/icons/Remove"
import AddIcon from "@material-ui/icons/Add"

const Menu = ({ style, children, isOpen, setOpen }) => {
  const trail = useTrail(children.length, {
    mass: 5,
    tension: 1000,
    friction: 150,
    opacity: isOpen ? 1 : 0,
    x: isOpen ? 0 : 5,
    height: isOpen ? 57 : 0,
    from: { opacity: 0, x: 0, height: 0 },
  })

  const transitions = useTransition(isOpen, null, {
    from: { position: "absolute", opacity: 0, left: "-1em" },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  })

  return (
    <nav title="Main Menu">
      <Button
        sx={{
          ...style,
          display: "flex",
          position: "relative",
          padding: "0px",
          margin: "0px",
          background: "transparent",
        }}
        onClick={() => setOpen(!isOpen)}
      >
        {transitions.map(({ item, key, props }, idx) =>
          item ? (
            <a.span key={idx} style={props}>
              <RemoveIcon fontSize="inherit" />
            </a.span>
          ) : (
            <a.span key={idx} style={props}>
              <AddIcon fontSize="inherit" />
            </a.span>
          )
        )}
        {"Menu"}
      </Button>
      {trail.map(({ x, height, ...rest }, index) => (
        <a.div
          key={index}
          style={{
            ...rest,
            height,
            pointerEvents: isOpen ? "all" : "none",
            transform: x.interpolate(x => `translate3d(0,${x}px,0)`),
          }}
        >
          <a.div style={{ height }}>{children[index]}</a.div>
        </a.div>
      ))}
    </nav>
  )
}

export default Menu
